export default {
  namespaced: true,
  breadcrumbs: {
    vaas:{
      camera_manager: {
        master_account: 'VaaS > Gestor de Cámaras > Cuenta Maestra',
        reseller: 'VaaS > Gestor de Cámaras > Revendedor',
        cameras: 'VaaS > Gestor de Cámaras > Cámaras',
        status_cameras: 'VaaS > Gestor de Cámaras > Estado de Cámaras',
      },
      safr: {
        cameras: 'VaaS > SAFR > Cámaras',
        master_accounts: 'VaaS > SAFR > Cuentas Maestras',
        access_clearences: 'VaaS > SAFR > Accesos y Aclaramientos',
      },
      ee_vms: {
        master_accounts: 'VaaS > EE VMS > Cuentas Maestras',
        accounts: 'VaaS > EE VMS > Cuentas',
        bridges: 'VaaS > EE VMS > Puentes',
        cameras: 'VaaS > EE VMS > Cámaras',
        presets: 'VaaS > EE VMS > Ajustes Preestablecidos',
      },
      luxriot: {
        master_accounts: 'VaaS > Luxriot > Cuentas Maestras',
        cameras: 'VaaS > Luxriot > Cámaras',
      },
      omnicloud: {
        master_accounts: 'VaaS > OmniCloud > Cuentas Maestras',
        cameras: 'VaaS > OmniCloud > Cámaras',
        omnia_reseller: 'VaaS > OmniCloud > Revendedor de Omnia',
      },
      dahua: {
        dahua_dvr: 'VaaS > Dahua > Dahua DVR',
        dahua_cameras: 'VaaS > Dahua > Cámaras Dahua',
      },
      hanwha: {
        hanwha_dvr: 'VaaS > Hanwha > Hanwha DVR',
        hanwha_cameras: 'VaaS > Hanwha > Cámaras Hanwha',
      },
      hikvision: {
        master_accounts: 'VaaS > Hikvision > Cuentas Maestras',
        hikvision_dvr: 'VaaS > Hikvision > Hikvision DVR',
        hikvision_cameras: 'VaaS > Hikvision > Cámaras Hikvision',
      },
      generic_devices: 'VaaS > Dispositivos Genéricos',
      proxy_rtsp_server: 'VaaS > Servidores Proxy RTSP',
      recording_requests: {
        tag: 'VaaS > Solicitudes de Grabación > Etiqueta',
        recording_requests: 'VaaS > Solicitudes de Grabación > Solicitudes de Grabación',
      },
      analytics: {
        facial_recognition: {
          sarf: {
            events: 'VaaS > Analíticas > Reconocimiento Facial > SAFR > Eventos',
            groups: 'VaaS > Analíticas > Reconocimiento Facial > SAFR > Grupos',
            people: 'VaaS > Analíticas > Reconocimiento Facial > SAFR > Personas',
          },
          luna: {
            master_accounts: 'VaaS > Analíticas > Reconocimiento Facial > Luna > Cuentas Maestras',
            list: 'VaaS > Analíticas > Reconocimiento Facial > Luna > Lista',
            face: 'VaaS > Analíticas > Reconocimiento Facial > Luna > Rostro',
            facial_recognition_matches: 'VaaS > Analíticas > Reconocimiento Facial > Luna > Coincidencias de Reconocimiento Facial',
            facestream: 'VaaS > Analíticas > Reconocimiento Facial > Luna > Transmisión Facial',
          }
        },
        lpr: {
          plate_list: 'VaaS > Analíticas > LPR > Lista de Placas',
          plate: 'VaaS > Analíticas > LPR > Placas',
          lpr_matches: 'VaaS > Analíticas > LPR > Coincidencias de LPR',
        },
        detections_events: 'VaaS > Analíticas > Eventos de Detección',
      },
      video_watermarks: 'VaaS > Marcas de Agua en Video',
      pacom: {
        master_accounts : 'IoT > Pacom > Cuentas Maestras',
        sites: 'IoT > Pacom > Sitios',
        actions: 'VaIoTss > Pacom > Acciones',
        schemaTypes: 'IoT > Pacom > Tipos de Esquema',
        entries: 'IoT > Pacom > Entradas',
        alarms: 'IoT > Pacom > Alarmas',
        alarmTypes: 'IoT > Pacom > Tipos de alarma',
        logs: 'IoT > Pacom > Logs'
      }
    },
    tenants: {
      all_tenants: 'Tenanants > Todos los Tenanants',
      master_tenants: 'Tenanants > Tenanants Maestros',
      incident_list: 'Tenanants > Lista de Incidentes',
      incident_chart: 'Tenanants > Gráfico de Incidentes',
      logs_incidents: 'Tenanants > Registros de Incidentes',
      layouts: 'Tenanants > Diseños',
      device_tag: 'Tenanants > Etiqueta del Dispositivo',
      token: 'Tenanants > Token',
      token_omnitag: 'Tenanants > Token Omnitag',
      tenants_storage: 'Tenants > Tenants Almacenamiento',
      tenants_storage_files: 'Tenants > Tenants Almacenamiento > Tenant Archivos',
    },
    users: {
      all_users: 'Usuarios > Todos los Usuarios',
      profiles: 'Usuarios > Perfiles',
      permissions: 'Usuarios > Permisos',
      groups: 'Usuarios > Grupos',
      users_app: 'Usuarios > Usuarios de la Aplicación',
    },
    alarms: {
      all: 'Alarmas > Todas',
      seproban: 'Alarmas > Seproban',
      alarms_levels: 'Alarmas > Niveles de Alarmas',
      alarm_comment: 'Alarmas > Comentario de Alarma',
      alarm_views: 'Alarmas > Vistas de Alarma',
      alarm_purge: 'Alarmas > Purga de Alarmas',
    },
    facilities: {
      all_facilities: 'Instalaciones > Todas las Instalaciones',
      centers: 'Instalaciones > Centros',
      sectors: 'Instalaciones > Sectores',
      municipalities: 'Instalaciones > Municipios',
    },
    logs: {
      system_logs: 'Registros > Registros del Sistema',
      traffic: 'Registros > Tráfico',
      command_logs: 'Registros > Registros de Comandos',
      action_plan_logs: 'Registros > Registros de Planes de Acción',
    },
    iot: {
      buttons: {
        all_buttons: 'IoT > Todos los Botones',
        button_types: 'IoT > Tipos de Botones',
      },
      intelbras: {
        master_accounts: 'IoT > Intelbras > Cuentas Maestras',
        sites: 'IoT > Intelbras > Sitios',
        alarm_types: 'IoT > Intelbras > Reglas',
        alarms: 'IoT > Intelbras > Alarmas',
        log: 'IoT > Intelbras > Registro',
        rules: 'IoT > Intelbras > Reglas',
      },
      dmp: {
        master_accounts: 'IoT > Dmp > Cuentas Maestras',
        panels: 'IoT > Dmp > Paneles',
        alarm_types: 'IoT > Dmp > Reglas',
        alarms: 'IoT > Dmp > Alarmas',
        log: 'IoT > Dmp > Registro',
        rules: 'IoT > Dmp > Reglas',
        profiles: 'IoT > Dmp > Perfiles',
        servers: 'IoT > Dmp > Servidores'
      },
      bosch: {
        panels: 'IoT > Bosch > Paneles',
        log: 'IoT > Bosch > Registro',
        rules: 'IoT > Bosch > Reglas',
        profiles: 'IoT > Bosch > Perfiles',
      }
    },
    automation: {
      custom_command: 'Automatización > Comando Personalizado',
      workflow: 'Automatización > Flujo de Trabajo',
      action_plan: 'Automatización > Plan de Acción',
      document_action_plan: 'Automatización > Documentos de Plan de Acción',
      schedule_task: 'Automatización > Tarea Programada',
      alarm_commands: 'Automatización > Comandos de Alarma',
      scripts: 'Automatización > Comandos',
    },

    voip: {
      iotcomms_master_accounts: 'VoIP > Cuentas Maestras de IoTComms',
      types_devices_interphones: 'VoIP > Tipos de Dispositivos Interfonos',
      devices_interphones: 'VoIP > Dispositivos Interfonos',
      calls: 'VoIP > Llamadas',
      omnicloud: {
        master_account: 'VoIP > Omnicloud > Cuentas Maestras',
        devices: 'VoIP > Omnicloud > Dispositivos',
        calls: 'VoIP > Omnicloud > Llamadas',
      }
    },
    risk: {
      risk_templates: "Evaluación de Riesgo > Plantillas Formulario"
    },
    security_self_audit:{
      templates : "Auto Auditorías de Seguridad > Plantillas Formulario",
      audits: "Auto Auditorías de Seguridad > Auditorías"
    },
    maintenance: {
      crew: 'Mantenimiento > Equipo de Mantenimiento',
      companies: 'Mantenimiento > Empresas de Mantenimiento',
      templates: 'Mantenimiento > Plantillas de Mantenimiento',
      forms: 'Mantenimiento > Formularios de Mantenimiento',
    },
  },
}
